module.exports = {
  success: {
    delete_incomplete_uploads: '删除文件碎片成功',
    clear_incomplete_uploads: '清空碎片完成，成功删除 {count} 项',
    set_versioning: '版本控制设置成功',
    move_files: '成功移动 {count} 个文件/文件夹',
    copy_files: '成功复制 {count} 个文件/文件夹',
    copy: '复制成功',
    move: '移动成功',
    rename: '重命名成功',
    edit_public_permission: '编辑公共权限成功',
    save: '保存成功',
    add: '添加成功',
    modify: '修改成功',
    delete: '删除成功',
    copy_path: '导航路径复制成功',
    restore_files: '成功发起 {count} 个文件/文件夹恢复',
  },

  fail: {
    delete_incomplete_uploads: '删除文件碎片失败',
    set_versioning: '版本控制设置失败',
    move_files: '{count} 个文件/文件夹移动失败',
    copy_files: '{count} 个文件/文件夹复制失败',
    rename_files: '{count} 个文件/文件夹重命名失败',
    copy: '复制失败',
    move: '移动失败',
    rename: '重命名失败',
    convert_to_encode_param: '转为 {encode} 编码失败',
    save: '保存失败',
    restore_files: '发起 {count} 个文件/文件夹恢复失败',
    get_share_link: '获取分享链接失败',
    share: '分享失败',
    create_folder: '新建文件夹失败',
  },
};
